import React, { useEffect, useState } from 'react';
import {
  EditBase,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useUpdate,
  required,
  useDataProvider,
  useEditContext,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";
import ItemSelectInput from '../../components/ItemSelectInput.tsx';

/**
 * 外层：只负责提供 EditContext
 */
const MaterialCostEdit: React.FC = () => (
  <EditBase resource="materialCost">
    <MaterialCostEditForm />
  </EditBase>
);

export default MaterialCostEdit;

/**
 * 内层：这里才可以安全使用 useEditContext
 */
const MaterialCostEditForm: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const [update] = useUpdate();

  const { record } = useEditContext(); // ✅ 正确位置

  const [loading, setLoading] = useState(true);
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);

  // -----------------------------
  // 加载 Raw Material / Packaging Material
  // -----------------------------
  useEffect(() => {
    setLoading(true);
    dataProvider.getList('bom/getFinishedGoodsSelectInput', {
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'productId', order: 'ASC' },
      filter: { type: 'RawMaterial|PackagingMaterial' },
    })
      .then((res) => {
        setRawMaterials(res.data);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        notify('Error loading materials', { type: 'warning' });
        setLoading(false);
      });
  }, [dataProvider, notify]);

  if (loading) return <span>Loading...</span>;
  if (!record) return <span>No material cost record found</span>;

  // -----------------------------
  // 保存
  // -----------------------------
  const handleSave = async (data: any) => {
    try {
      const productId = data.productId?.productId ?? data.productId;

      const payload = {
        ...data,
        productId,
      };

      await update('materialCost', {
        id: record.id,
        data: payload,
      });

      notify('Material cost updated successfully', { type: 'success' });
      redirect('list', 'materialCost');
    } catch (error) {
      notify('Update failed', { type: 'error' });
    }
  };

  return (
    <SimpleForm
      sx={{ backgroundColor: '#ffffff', padding: '36px' }}
      onSubmit={handleSave}
    >
      <Box display="flex" flexWrap="wrap" gap={2}>

        {/* Raw Material / Packaging Material */}
        <Box flex="1 1 48%">
          <TextInput readOnly label="Product Id" source="productId" />
        </Box>
        <Box flex="1 1 48%">
          <TextInput readOnly label="Product Name" source="productName" />
        </Box>

        {/* Material Cost */}
        <Box flex="1 1 48%">
          <TextInput
            source="cost"
            label="Material Cost"
            fullWidth
            validate={required()}
          />
        </Box>

        {/* Cost Unit */}
        <Box flex="1 1 48%">
          <TextInput
            source="costUnit"
            label="Cost Unit"
            fullWidth
            validate={required()}
          />
        </Box>

      </Box>
    </SimpleForm>
  );
};
